import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      // Use current route URL as redirect URI
      const currentUrl = `${window.location.origin}/#${state.url}`;
      // Redirect to login with the current URL

      await this.keycloak.login({
        redirectUri: currentUrl
      });
      return false; // Return false to prevent navigation until login completes
    }

    // Allow access if authenticated
    return this.authenticated;
  }
}
